import React, { useState, useEffect, useRef } from "react";
import * as _f_ from "@Funciones/funciones";
import * as _btn_ from "@Elementos/Boton";
import * as _ipt_ from "@Elementos/Input";

export const Opcion1 = ({
  texto = "",
  clave = [],
  valor = [],
  opciones = [],
  name = "",
  estilos = {},
  seleccionado = "3",
  ...props
}) => {
  return (
    <select className="Opcion1" defaultValue="">
      <option value="" hidden disabled>
        {texto}
      </option>
      <option>uno</option>
      <option>dos</option>
    </select>
  );
};

export const Opcion2 = ({
  texto = "",
  clave = [],
  valor = [],
  opciones = [],
  name = "",
  estilos = {},
  seleccionado = "",
  _ref = null,
  ...props
}) => {
  const opcionInput = useRef(null);
  const contenedorOpciones = useRef(null);
  const [opcionSeleccionada, eopcionSeleccionada] = useState(null);
  const [opcionesFiltro, eopcionesFiltro] = useState(null);
  const [seleccioneOpcion, eseleccioneOpcion] = useState(false);
  const [v_u, ev_u] = useState({
    mostrar_op: false,
  });
  useEffect(() => {
    
    const objetoEncontrado = opciones.find((item) => {
      return clave.some((prop) => String(item[prop]) === String(seleccionado));
    });
    let resultado = "";

    if (objetoEncontrado) {
      resultado = valor
        .map((prop) => objetoEncontrado[prop])
        .filter(Boolean)
        .join(" ");
    }
    opcionInput.current.setAttribute("value", seleccionado);
    opcionInput.current.value = resultado;
  }, [seleccionado]);
  
  function mostrarOpciones(evento) {
    let contOp = contenedorOpciones.current;
    let inputOp = opcionInput.current;

    const rectPadre = inputOp.getBoundingClientRect();
    contOp.style.position = "fixed";
    contOp.style.top = rectPadre.bottom + "px";
    contOp.style.left = rectPadre.left + "px";
    // Opcional: Que el hijo mida lo mismo que el padre
    contOp.style.width = rectPadre.width + "px";
    ev_u((prev) => ({ ...prev, mostrar_op: true }));
  }
  function ocultarOpciones(evento) {
    ev_u((prev) => ({ ...prev, mostrar_op: false }));
    eopcionesFiltro(null);
    if (!seleccioneOpcion) {
      opcionInput.current.value = "";
    } else {
      const opcionExistente = opciones.filter((n) => {
        return _f_.coincidenciaTotal(
          opcionInput.current.value,
          valor.map((cl) => n[cl]).join(" "),
        );
      });
      if (opcionExistente.length == 0) {
        opcionInput.current.value = "";
        eseleccioneOpcion(false);
      }
    }
    if (props.onBlur ?? false) {
      props?.onBlur(evento);
    }
  }
  function seleccionarOpcion(evento) {
    opcionInput.current.value = evento.target.textContent;
    opcionInput.current.setAttribute(
      "value",
      evento.target.getAttribute("value"),
    );
    eseleccioneOpcion(true);
    //console.log(evento.target.getAttribute("value"));
    if (_ref !== null) {
      _ref.current = evento.target.getAttribute("value");
    }
  }
  function filtrarOpciones(evento) {
    eopcionesFiltro(
      opciones.filter((n) => {
        return _f_.coincidenciaParcial(
          opcionInput.current.value,
          valor.map((cl) => n[cl]).join(" "),
        );
      }),
    );
  }
  return (
    <div className="Opcion2" style={_f_.estilosObjetoVariablesCSS(estilos)}>
      <_ipt_.Input4
        texto={texto}
        tipo="text"
        name={name}
        ref={opcionInput}
        estilos={estilos}
        onFocus={mostrarOpciones}
        onBlur={ocultarOpciones}
        onChange={filtrarOpciones}
        autoComplete="off"
      />
      <div
        className={`Opcion2-opciones ${v_u.mostrar_op ? "Opcion2-opciones-mostrar" : "Opciones-opciones-ocultar"}`}
        style={{...estilos}}
        ref={contenedorOpciones}
      >
        <div
          className="Opcion2-item"
          value={""}
          onMouseDown={seleccionarOpcion}
        >
          {"..."}
        </div>
        {(opcionesFiltro || opciones).map((op, i) => {
          return (
            <div
              className="Opcion2-item"
              key={i}
              value={clave.map((cl) => op[cl]).join("-")}
              onMouseDown={seleccionarOpcion}
            >
              {valor.map((cl) => op[cl]).join(" ")}
            </div>
          );
        })}
      </div>
    </div>
  );
};
